import type { SaveProjectBodyMetadataVisibility } from './saveProjectBodyMetadataVisibility';

/**
 * 프로젝트 메타데이터 (JSON 형식)
 */
export type SaveProjectBodyMetadata = {
  /**
   * 프로젝트 설명
   * @maxLength 5000
   */
  description?: string;
  /** 프로젝트 태그 목록 (주의 서버 측에서 @RequestParam List<String>으로 처리됨) */
  tags?: string[];
  /**
   * 프로젝트 제목
   * @maxLength 200
   */
  title: string;
  /** 프로젝트 공개 설정 */
  visibility?: SaveProjectBodyMetadataVisibility;
};
